// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"fade-image_wrapper__ECi4Q","newImg":"fade-image_newImg__R3MOx","visible":"fade-image_visible__Fn54r"};